import React from 'react';

import './progress-bar.css';

const ProgressBar: React.FC<{}> = () => {
	return (
		<div
			className="w-full relative h-1 rounded-2xl bg-neutral"
			data-testid="progressbar-component">
			<div className="color absolute h-1 rounded-2xl w-1/3 bg-brand"></div>
		</div>
	);
};

export default ProgressBar;
